<div *ngIf="isDataExist" class="justify-content-end m-t-10 m-b-20">
	<button class="w-25" mat-raised-button color="accent" (click)="showTotalPerBenefitsFamily()">
		<mat-icon class="font-medium">visibility</mat-icon>
		Utilisation Per Benefit Family
	</button>
</div>

<ng-container *ngIf="isDataExist;
                  then showTable else emptyPlaceHolder"></ng-container>

<ng-template #showTable>
	<div>
		<h4 class="mat-primary-color">Hint: click on a row to expand more information</h4>
	</div>
	<div class="mat-elevation-z8 table-container">
		<table mat-table multiTemplateDataRows [dataSource]="dataSource"
					 matSort #MatSortUtilisationStep="matSort">

			<ng-container [matColumnDef]="tableColumns.ActivityId">
				<th *matHeaderCellDef mat-header-cell mat-sort-header>Activity ID</th>
				<td *matCellDef="let row" mat-cell> {{row.activityId}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.ActivityStartDate">
				<th *matHeaderCellDef mat-header-cell mat-sort-header class="w-10">Date</th>
				<td *matCellDef="let row" mat-cell> {{row.activityStartDate | date: dateFormat}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.Type">
				<th *matHeaderCellDef mat-header-cell mat-sort-header class="w-10">Type</th>
				<td *matCellDef="let row" mat-cell> {{row.type}}</td>
			</ng-container>
			
			<ng-container [matColumnDef]="tableColumns.Provider">
				<th *matHeaderCellDef mat-header-cell mat-sort-header class="w-15">Provider</th>
				<td *matCellDef="let row" mat-cell
						[matTooltip]="row.provider?.name">
					{{row.provider?.name | truncateText: {sliceEnd: 30} }}
				</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.TariffCode">
				<th *matHeaderCellDef mat-header-cell mat-sort-header class="w-15">Tariff Code</th>
				<td *matCellDef="let row" mat-cell
						[matTooltip]="row.tariffCode+':'+row.tariffDescription">
					{{row.tariffCode}}: {{row.tariffDescription | truncateText: {sliceEnd: 30}
					}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.BenefitFamily">
				<th *matHeaderCellDef mat-header-cell mat-sort-header class="w-10">Benefit Family</th>
				<td *matCellDef="let row" mat-cell> {{row.benefitFamily}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.Benefit">
				<th *matHeaderCellDef mat-header-cell mat-sort-header class="w-15">Benefit</th>
				<td *matCellDef="let row" mat-cell
						[matTooltip]="row.benefitCode+':'+row.benefitName">
					{{row.benefitCode}}: {{row.benefitName | truncateText: {sliceEnd: 30} }}
				</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.Quantity">
				<th *matHeaderCellDef mat-header-cell mat-sort-header>Qty</th>
				<td *matCellDef="let row" mat-cell> {{row.requestedQuantity}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.AmountClaimed">
				<th *matHeaderCellDef mat-header-cell mat-sort-header class="w-10">Claimed Amt</th>
				<td *matCellDef="let row" mat-cell> {{row.amountClaimed | number: '.2'}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.AmountBenefit">
				<th *matHeaderCellDef mat-header-cell mat-sort-header class="w-10">Benefit Amt</th>
				<td *matCellDef="let row" mat-cell> {{row.amountBenefit | number: '.2'}}</td>
			</ng-container>

			<!--
				 Note: No "mat-sort-header" since No property corresponds to BE payload
				 to which filter can be applied this is basically sum of 2 amounts displayed into UI
			-->
			<ng-container [matColumnDef]="tableColumns.TotalAmount">
				<th *matHeaderCellDef mat-header-cell class="w-10">Total Amt</th>
				<td *matCellDef="let row" mat-cell> {{row.amountApproved + row.amountBenefit | number: '.2'}}</td>
			</ng-container>

			<ng-container [matColumnDef]="tableColumns.AdjudicationStatus">
				<th *matHeaderCellDef mat-header-cell mat-sort-header>status</th>
				<td *matCellDef="let row" mat-cell> {{row.adjudicationStatus?.name}}</td>
			</ng-container>

			<!--Expanded Section -->
			<ng-container matColumnDef="expandedDetail">
				<td *matCellDef="let row" mat-cell [attr.colspan]="displayedColumns.length">
					<div class="row-detail-container"
							 [@detailExpand]="row == utilisationExpandedRow ? 'expanded' : 'collapsed'">

						<ng-container *ngIf="row?.consumedLimits?.length; else noConsumedLimit">
							<div *ngFor="let consumedLimit of row?.consumedLimits; let idx=index">
								<p>Consumed Limit {{idx + 1}}</p>
								<b>Limit: </b>{{consumedLimit?.limit?.name}}<br>
								<b>Type: </b>{{consumedLimit?.limit?.limitType?.name}}<br>
								<b>Measure: </b>{{consumedLimit?.limit?.measure?.name}}<br>
								<b>Accumulate By: </b>{{consumedLimit?.limit?.accumulateBy?.name}}<br>
								<b>Accumulate At: </b>{{consumedLimit?.limit?.accumulateAt?.name}}<br>
								<b>Limit Value: </b>{{consumedLimit?.limit?.value  | number: '.2'}}<br>
								<b>Amount Consumed: </b>{{consumedLimit?.consumedLimitAmountProductCurrency  | number: '.2'}}<br>
								<br />
							</div>
						</ng-container>
						<ng-template #noConsumedLimit>
							<h4 class="mat-primary-color center-align">
								There is no data for the consumed limits of this activity
							</h4>
						</ng-template>
					</div>
				</td>
			</ng-container>


			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;" class="row"
					[class.expanded-row]="utilisationExpandedRow == row"
					(click)="utilisationExpandedRow = utilisationExpandedRow === row ? null : row">
			</tr>
			<tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
		</table>

		<mat-paginator #utilisationPaginator (page)="pageChanged($event)"
									 [pageIndex]="0" [pageSize]="tableControl.pageSize"
									 [pageSizeOptions]="tableControl.pageSizeOptions"
									 [length]="tableControl.length">
		</mat-paginator>
	</div>

	<ng-container [ngTemplateOutlet]="PrevAndNextButtons"></ng-container>

</ng-template>

<ng-template #emptyPlaceHolder>
  <div class="text-center">
    <label class="column-label claim-column-label">No utilisation data</label>
  </div>
  <ng-container [ngTemplateOutlet]="PrevAndNextButtons"></ng-container>
</ng-template>

<ng-template #PrevAndNextButtons>
  <div class="button-container">
    <button mat-raised-button matStepperPrevious color="primary">Back</button>
    <button mat-raised-button matStepperNext color="primary">Next</button>
  </div>
</ng-template>
